import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useHeaderAction } from "../../../core/provider/HeaderActionProvider/HeaderAction.js";
import BottomNavigation from "../../ui/BottomNavigation/index.js";
import HeaderMainPages from "../../ui/HeaderMainPages/index.js";

interface MainLayoutProps {
  showFooter?: boolean;
  navItems?: Array<{
    icon: React.ReactNode;
    label: string;
    path: string;
  }>;
}

export default function OwnerLayout({ navItems = [] }: MainLayoutProps) {
  const { action } = useHeaderAction();
  const location = useLocation();
  const noHeaderRoutes = ["/owner/finance"];
  const noFooterRoutes = [
    "/owner/services/fire-insurance",
    "/owner/services/fire-insurance/inquiry",
    "/owner/services/lease-renewal",
    "/owner/services/lease-renewal/inquiry",
    "/owner/services/lease-request",
    "/owner/services/lease-request/inquiry-add",
    "/owner/services/lease-request/inquiry-edit/:id",
    "/owner/profile/editeProfile",
    "/owner/profile/tenantFees",
    "/owner/profile/notifications",
    "/owner/profile/ticket",
    "/owner/profile/rules",
    "/owner/profile/about",
  ];
  const showHeader = !noHeaderRoutes.some((route) =>
    location.pathname.startsWith(route),
  );
  const showFooter = !noFooterRoutes.some((route) =>
    location.pathname.startsWith(route),
  );
  return (
    <div className="w-full max-w-[450px] 3xl:max-w-[504px] h-dvh bg-gray-200 shadow-2xl overflow-hidden relative flex flex-col rounded-none md:rounded-t-2xl border-0 md:border border-gray-200 mx-auto">
      {showHeader && (
        <>
          {!action && (
            <header className="h-16 bg-gray-200  flex items-center justify-between px-4 shrink-0 z-20 ">
              <HeaderMainPages />
            </header>
          )}

          {action && (
            <header className="h-16 bg-gray-200  border-gray-100 flex items-center px-4 shrink-0 z-20">
              <div className="flex-1">{action}</div>
            </header>
          )}
        </>
      )}
      <main className="flex-1 min-h-0 rounded-t-2xl overflow-y-auto no-scrollbar bg-white scroll-smooth">
        <div className={`${showFooter ? "pb-24" : "pb-4"} ${showHeader ? "p-4" : "p-0"}`}>
          <Outlet />
        </div>
        {/* {showFooter && <BottomNavigation items={OWNER_NAV_ITEMS} />} */}
      </main>
    </div>
  );
}
